import React, { ReactElement, ReactNode, useState } from 'react';

import { Panel } from '@/components/Collapse/components/Panel';

import * as S from './Collapse.styles';

type Props = {
  items: Array<{
    children: ReactElement | ReactNode;
    key: string | number;
    header: string;
  }>;
  defaultOpen?: Array<string | number>;
  accordion?: boolean;
};

export const Collapse = ({
  items = [],
  defaultOpen = [],
  accordion = false
}: Props) => {
  const [openedPanels, setOpenedPanels] = useState<Array<string | number>>(
    accordion && defaultOpen.length ? [defaultOpen[0]] : defaultOpen
  );

  const handleChange = (key: string | number) =>
    setOpenedPanels(prev => {
      if (accordion) return prev[0] === key ? [] : [key];

      const existingIndex = prev.indexOf(key);

      if (existingIndex >= 0) {
        const shallowCopy = [...prev];
        shallowCopy.splice(existingIndex, 1);
        return shallowCopy;
      }

      return [...prev, key];
    });

  return (
    <S.Wrapper>
      {items.map(({ children, key, header }) => {
        const isOpen = openedPanels.includes(key);
        return (
          <Panel
            key={key}
            header={header}
            value={key}
            isOpen={isOpen}
            onChange={handleChange}
          >
            {children}
          </Panel>
        );
      })}
    </S.Wrapper>
  );
};
